import { create } from 'zustand';
import { UserResponseDto } from '../dtos/user/response/userResponseDto';

export interface UserStore {
    userInfo: UserResponseDto | undefined;
    setUserInfo: (userInfo: UserResponseDto) => void;
}

/**
 * 사용자 관리 스토어
 * 사용자 관련 상태와 액션을 관리
 */
const useUserStore = create<UserStore>((set) => ({
    userInfo: undefined,
    setUserInfo: (userInfo: UserResponseDto) => set({ userInfo }),
}));

export default useUserStore;